var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrameApi',{attrs:{"endpoint":_vm.endpoint,"immediate":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var products = ref.data;
return [_c('ProductGrid',{attrs:{"products":products,"data-qa":"product teaser"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }